// extracted by mini-css-extract-plugin
export default {"card":"Final-module__card-Iqwvek","fade-in":"Final-module__fade-in-n50SQz","button":"Final-module__button-vwW7UM","finalSubtitle":"Final-module__finalSubtitle-cUpEws"};